/**
 * icon:菜单项图标
 * roles:标明当前菜单项在何种角色下可以显示，如果不写此选项，表示该菜单项完全公开，在任何角色下都显示
 */
import { HomeOutlined, TableOutlined, DesktopOutlined, FileImageOutlined } from '@ant-design/icons';

const menuList = [
  {
    title: "课程管理",
    path: "/course",
    icon: <DesktopOutlined />,
    children: [
      {
        title: "课程列表",
        path: "/course/list",
        auth: true
      },
      {
        title: "创建系列课",
        path: "/course/series/create",
        auth: true
      },
      {
        title: "创建单课",
        path: "/course/single/create",
        auth: true
      },
      {
        title: "修改课程",
        path: "/course/series/:id",
        hide: true,
        auth: true
      },
      {
        title: "修改课程",
        path: "/course/single/:id",
        hide: true,
        auth: true
      }
    ]
  },
  {
    title: "学员管理",
    path: "/student",
    icon: <TableOutlined />,
    children: [
      {
        title: "学员列表",
        path: "/student/list",
        auth: true,
      }
    ]
  },
  {
    title: "讲师管理",
    path: "/teacher",
    icon: <TableOutlined />,
    children: [
      {
        title: "讲师列表",
        path: "/teacher/list",
        auth: true
      },{
        title: "新建讲师",
        path: "/teacher/create",
        auth: true,
      },{
        title: "修改讲师",
        path: "/teacher/:id",
        hide: true,
        auth: true,
      }
    ]
  },
  {
    title: "学校管理",
    path: "/school",
    icon: <TableOutlined />,
    children: [
      {
        title: "参会学校",
        path: "/school/list",
        auth: true
      },{
        title: "学校图库",
        path: "/school/gallery",
        auth: true,
      },{
        title: "修改学校",
        path: "/school/:id",
        hide: true,
        auth: true,
      }
    ]
  },
  {
    title: "招聘会管理",
    path: "/jobfair",
    icon: <TableOutlined />,
    children: [
      {
        title: "招聘会宣传列表",
        path: "/jobfair/list",
        auth: true
      },{
        title: "修改招聘会",
        path: "/jobfair/:id",
        hide: true,
        auth: true,
      }
    ]
  },
]

export default menuList
